import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { getLocalStorage } from "../utils";

import { getURLstylistCode } from "../utils/globalFunctions";

/**
 * Gate consumer booking pages behind a stored access token.
 * Unauthenticated visitors are sent to sign-in with a return path.
 */
export default function ProtectedRoute() {
  const access_token = getLocalStorage("access_token");
  const location = useLocation();
  const stylistCode = getURLstylistCode();
  const next = encodeURIComponent(`${location.pathname}${location.search}`);

  return access_token ? (
    <Outlet />
  ) : (
    <Navigate to={`/${stylistCode}/signin/?notlogged&next=${next}`} />
  );
}
